import React from "react";
import Line from "../../../assets/line2.svg";
import MainImg from "../../../assets/illustrations2/PNG/extension_page_v-a__email_ext_profile.png";

export default function Context() {
  return (
    <div>
      <div className="bg-gray-100 p-8 lg:pr-20 lg:pl-10">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8 lg:mb-0">
          <div
            className={`flex justify-center items-center mt-8 md:mt-0 md:w-[40%] md:order-2`}
          >
            <img
              src={MainImg}
              alt="Expanded section preview"
              className="md:w-full w-96"
            />
          </div>

          <div className={`text-left md:w-[60%] md:order-1 lg:mt-10 md:pr-6`}>
            <h2 className="text-3xl sm:text-4xl lg:text-[43px] lg:leading-[1.4em] font-bold">
              How It{" "}
              <span className="relative inline-block">
                Works
                <img
                  src={Line}
                  alt="Underline decoration"
                  className="absolute bottom-0 left-0 w-full top-8 lg:top-[50px]"
                />
              </span>
            </h2>
            <p className="text-lg my-3">
              Download our Google Sheets add-on to enable seamless integration
              with our email finder.
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-[43px] lg:leading-[1.4em] font-bold">
              Add Our Tool to{" "}
              <span className="relative inline-block">
                Google Sheets
                <img
                  src={Line}
                  alt="Underline decoration"
                  className="absolute bottom-0 left-0 w-full top-9 lg:top-[50px]"
                />
              </span>
            </h2>
            <p className="text-lg my-3">
              Download our Google Sheets add-on to connect with our email
              finder.{" "}
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-[43px] lg:leading-[1.4em] font-bold">
              Enter Your{" "}
              <span className="relative inline-block">
                Search Details
                <img
                  src={Line}
                  alt="Underline decoration"
                  className="absolute bottom-0 left-0 w-full top-9 lg:top-[50px]"
                />
              </span>{" "}
            </h2>
            <p className="text-lg my-3">
              Search LinkedIn profiles and get verified email addresses with a
              single click.
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-[43px] lg:leading-[1.4em] font-bold">
              Get Verified{" "}
              <span className="relative inline-block">
                Emails
                <img
                  src={Line}
                  alt="Underline decoration"
                  className="absolute bottom-0 left-0 w-full top-9 lg:top-[50px]"
                />
              </span>{" "}
            </h2>
            <p className="text-lg my-3">
              With one click, add verified emails and contact details directly
              to your spreadsheet.
            </p>
            <h2 className="text-3xl sm:text-4xl lg:text-[43px] lg:leading-[1.4em] font-bold">
              Start{" "}
              <span className="relative inline-block">
                Outreach
                <img
                  src={Line}
                  alt="Underline decoration"
                  className="absolute bottom-0 left-0 w-full top-9 lg:top-[50px]"
                />
              </span>{" "}
            </h2>
            <p className="text-lg my-3 lg:mb-12">
              Use your email list for marketing, networking, or sales right
              away.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
